/* DHC B129 — popout cart recommendation quick add */
(function(){
  if(window.__DHC_CART_ADDONS_B125__) return;
  window.__DHC_CART_ADDONS_B125__=true;
  document.addEventListener('click',async function(e){
    var btn=e.target.closest('[data-dhc-addon-add]');
    if(!btn)return;
    e.preventDefault();
    var id=Number(btn.getAttribute('data-variant-id'));
    if(!id||btn.disabled)return;
    var old=btn.textContent;
    var box=btn.closest('[data-dhc-cart-addons]');
    var status=box&&box.querySelector('[data-dhc-addon-status]');
    btn.disabled=true;btn.textContent='ADDING…';
    if(status)status.textContent='';
    try{
      var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      var r=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})});
      if(!r.ok)throw new Error('Add failed');
      btn.textContent='✓ ADDED';
      if(status)status.textContent='Added to your cart.';
      var card=btn.closest('.dhc-cart-addon-card');
      var inDrawer=!!(box&&box.classList.contains('dhc-cart-addons--drawer'));
      document.dispatchEvent(new CustomEvent('dhc:cart:updated',{bubbles:true}));
      if(inDrawer){
        if(card){card.style.opacity='.45';card.style.pointerEvents='none';setTimeout(function(){card.remove();if(box&&!box.querySelector('.dhc-cart-addon-card'))box.style.display='none';},500);}
      }else{
        setTimeout(function(){window.location.reload();},350);
      }
    }catch(err){
      btn.disabled=false;btn.textContent=old;
      if(status)status.textContent='Could not add this item. Please try again.';
    }
  });
})();
